// extracted by mini-css-extract-plugin
module.exports = {"detailsPageBuilderList":"pageBuilderAttributes_detailsPageBuilderList__CI9RA","detailsPageBuilder":"pageBuilderAttributes_detailsPageBuilder__htXe1 my-0 mx-sm px-0 py-sm"};